var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c(
        "div",
        { staticClass: "columns is-mobile is-multiline" },
        [
          _c(
            "div",
            {
              staticClass:
                "column is-12-mobile is-4-tablet is-3-desktop is-2-fullhd",
            },
            [
              _c("div", { staticClass: "card folders-container" }, [
                _c(
                  "div",
                  { staticClass: "card-content px-0 pt-2 pb-3" },
                  [
                    _c("div", { staticClass: "row-folder-header" }, [
                      _vm.canGoToPreviousFolder
                        ? _c(
                            "a",
                            {
                              staticClass: "is-size-7",
                              on: { click: _vm.toPreviousFolder },
                            },
                            [
                              _c("i", { staticClass: "fas fa-reply fa-fw" }),
                              _vm._v(" Volver atrás"),
                            ]
                          )
                        : _vm.loadingFolders
                        ? _c("span", { staticClass: "is-size-7" }, [
                            _c("i", { staticClass: "fas fa-sync fa-spin" }),
                            _vm._v("  Cargando..."),
                          ])
                        : _c("span", { staticClass: "is-size-7" }, [
                            _c("i", { staticClass: "fas fa-info-circle" }),
                            _vm._v("  Nivel superior"),
                          ]),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.routes, function (route, index) {
                      return _c(
                        "div",
                        {
                          key: `folder-route-${index}`,
                          staticClass: "row-folder",
                          class: {
                            selected:
                              _vm.selectedFolder != null &&
                              _vm.selectedFolder.nombre ==
                                _vm.currentFolder.nombre &&
                              index == _vm.routes.length - 1,
                            dropping:
                              _vm.routes.slice(0, index + 1).join("/") ==
                              _vm.onDragFolderRoute,
                          },
                          style: { paddingLeft: `${20 + 12 * index}px` },
                          on: {
                            drop: function ($event) {
                              $event.preventDefault()
                              _vm.dropOnFolderRoute(
                                $event,
                                _vm.routes.slice(0, index + 1).join("/")
                              )
                            },
                            dragover: function ($event) {
                              $event.preventDefault()
                            },
                            dragenter: function ($event) {
                              _vm.onDragEnterFolderRoute(
                                $event,
                                _vm.routes.slice(0, index + 1).join("/")
                              )
                            },
                            dragleave: function ($event) {
                              _vm.onDragLeaveFolderRoute(
                                $event,
                                _vm.routes.slice(0, index + 1).join("/")
                              )
                            },
                            click: function ($event) {
                              if (
                                $event.ctrlKey ||
                                $event.shiftKey ||
                                $event.altKey ||
                                $event.metaKey
                              )
                                return null
                              return _vm.selectPreviousFolder(index)
                            },
                            dblclick: function ($event) {
                              _vm.dobleClickPreviousFolders(
                                _vm.routes.slice(0, index + 1).join("/")
                              )
                            },
                            contextmenu: function ($event) {
                              $event.preventDefault()
                              _vm.openContextMenuFolder(
                                _vm.currentFolder,
                                index,
                                $event,
                                _vm.routes.slice(0, index + 1).join("/")
                              )
                            },
                          },
                        },
                        [
                          index < _vm.routes.length - 1
                            ? _c(
                                "span",
                                { staticClass: "previous-unloaded-folders" },
                                [
                                  _c("i", {
                                    staticClass: "far fa-fw fa-lg",
                                    class: {
                                      "fa-folder-open": index > 0,
                                      "fa-building": index == 0,
                                    },
                                  }),
                                  _vm._v("  "),
                                  _c("b", [_vm._v(_vm._s(route))]),
                                ]
                              )
                            : route == "" &&
                              _vm.$store.getters.hasAnyRole(["lyris"])
                            ? _c("span", [
                                _c("i", {
                                  staticClass: "fab fa-fw fa-lg fa-pagelines",
                                }),
                                _vm._v("  "),
                                _c("b", [_vm._v("Raiz")]),
                              ])
                            : _c("span", [
                                _c("i", {
                                  staticClass: "far fa-fw fa-lg",
                                  class: {
                                    "fa-folder-open": index > 0,
                                    "fa-building": index == 0,
                                  },
                                }),
                                _vm._v("  "),
                                _c("b", [_vm._v(_vm._s(route))]),
                              ]),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.folders, function (folder, indexFolder) {
                      return _c(
                        "div",
                        {
                          key: `folder-${indexFolder}-${folder.id}`,
                          staticClass: "row-folder",
                          class: {
                            selected:
                              _vm.selectedFolder != null &&
                              folder.id == _vm.selectedFolder.id,
                            dropping: folder.id == _vm.onDragFolderId,
                          },
                          style: {
                            paddingLeft: `${20 + 12 * _vm.routes.length}px`,
                          },
                          on: {
                            drop: function ($event) {
                              $event.preventDefault()
                              return _vm.dropOnFolder($event, folder)
                            },
                            dragover: function ($event) {
                              $event.preventDefault()
                            },
                            dragenter: function ($event) {
                              return _vm.onDragEnterFolder($event, folder.id)
                            },
                            dragleave: function ($event) {
                              return _vm.onDragLeaveFolder($event, folder.id)
                            },
                            click: function ($event) {
                              if (
                                $event.ctrlKey ||
                                $event.shiftKey ||
                                $event.altKey ||
                                $event.metaKey
                              )
                                return null
                              return _vm.selectOneFolder(folder, indexFolder)
                            },
                            mouseup: function ($event) {
                              if ("button" in $event && $event.button !== 1)
                                return null
                              return _vm.middleClick(folder)
                            },
                            dblclick: function ($event) {
                              return _vm.dobleClick(folder)
                            },
                            contextmenu: function ($event) {
                              $event.preventDefault()
                              return _vm.openContextMenuFolder(
                                folder,
                                indexFolder,
                                $event
                              )
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa-fw fa-lg",
                            class: _vm.getIconFile(folder.tipo_documento_id),
                          }),
                          _vm._v(
                            "  " + _vm._s(folder.nombre) + "\n\n            "
                          ),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "infinite-loading",
                      {
                        attrs: { identifier: _vm.identifierLoaderFolders },
                        on: { infinite: _vm.infiniteHandlerFolders },
                      },
                      [
                        _c("span", {
                          attrs: { slot: "no-more" },
                          slot: "no-more",
                        }),
                        _vm._v(" "),
                        _c("span", {
                          attrs: { slot: "no-results" },
                          slot: "no-results",
                        }),
                      ]
                    ),
                  ],
                  2
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "column is-12-mobile is-8-tablet",
              class: {
                "is-6-desktop is-8-fullhd":
                  _vm.showSidebar || _vm.selectedDocumentsIndex.length > 1,
                "is-9-desktop is-10-fullhd":
                  !_vm.showSidebar && _vm.selectedDocumentsIndex.length <= 1,
              },
              on: {
                drop: function ($event) {
                  return _vm.dropFilesOverDocuments($event)
                },
                dragenter: function ($event) {
                  return _vm.onDragEnterOverDocuments($event)
                },
                dragleave: function ($event) {
                  return _vm.onDragLeaveOverDocuments($event)
                },
                dragover: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c("div", { staticClass: "card documents-container" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "overlay-dragging-files is-justify-content-center is-align-items-center",
                    class: { active: _vm.onDragDocumentsCounterAux > 0 },
                  },
                  [_vm._m(0)]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card-content px-0 pt-2 pb-3" },
                  [
                    _c("div", { staticClass: "row-file-header" }, [
                      _c("div", { staticClass: "row-file-name" }, [
                        _c(
                          "a",
                          {
                            staticClass: "has-text-dark",
                            class: {
                              "has-text-link":
                                _vm.queryDocuments.sort == "nombre",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.toggleSortDocuments("nombre")
                              },
                            },
                          },
                          [_c("b", [_vm._v("Nombre")])]
                        ),
                        _vm._v(" "),
                        _vm.queryDocuments.sort == "nombre" &&
                        _vm.queryDocuments.direction == "desc"
                          ? _c("i", {
                              staticClass:
                                "fas fa-sort-alpha-down fa-fw has-text-link",
                            })
                          : _vm.queryDocuments.sort == "nombre" &&
                            _vm.queryDocuments.direction == "asc"
                          ? _c("i", {
                              staticClass:
                                "fas fa-sort-alpha-up fa-fw has-text-link",
                            })
                          : _c("i", {
                              staticClass:
                                "fas fa-sort-alpha-up fa-fw has-text-kinda-dark",
                            }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row-file-date is-hidden-mobile" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "has-text-dark",
                              class: {
                                "has-text-link":
                                  _vm.queryDocuments.sort == "created_at",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleSortDocuments("created_at")
                                },
                              },
                            },
                            [_c("b", [_vm._v("Creado")])]
                          ),
                          _vm._v(" "),
                          _vm.queryDocuments.sort == "created_at" &&
                          _vm.queryDocuments.direction == "desc"
                            ? _c("i", {
                                staticClass:
                                  "fas fa-sort-numeric-up fa-fw has-text-link",
                              })
                            : _vm.queryDocuments.sort == "created_at" &&
                              _vm.queryDocuments.direction == "asc"
                            ? _c("i", {
                                staticClass:
                                  "fas fa-sort-numeric-down fa-fw has-text-link",
                              })
                            : _c("i", {
                                staticClass:
                                  "fas fa-sort-numeric-down fa-fw has-text-kinda-dark",
                              }),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._m(1),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.documents, function (document, indexDocument) {
                      return _c(
                        "div",
                        {
                          key: `document-${indexDocument}-${document.id}`,
                          staticClass: "row-file",
                          class: {
                            selected: _vm.selectedDocumentsId.includes(
                              document.id
                            ),
                          },
                          attrs: { draggable: "" },
                          on: {
                            click: [
                              function ($event) {
                                if (
                                  $event.ctrlKey ||
                                  $event.shiftKey ||
                                  $event.altKey ||
                                  $event.metaKey
                                )
                                  return null
                                return _vm.selectOneDocument(
                                  document,
                                  indexDocument
                                )
                              },
                              function ($event) {
                                if (!$event.ctrlKey) return null
                                if (
                                  $event.shiftKey ||
                                  $event.altKey ||
                                  $event.metaKey
                                )
                                  return null
                                return _vm.toggleOneDocument(
                                  document,
                                  indexDocument
                                )
                              },
                              function ($event) {
                                if (!$event.shiftKey) return null
                                if (
                                  $event.ctrlKey ||
                                  $event.altKey ||
                                  $event.metaKey
                                )
                                  return null
                                return _vm.toggleSelectDocumentShift(
                                  document,
                                  indexDocument
                                )
                              },
                            ],
                            mouseup: function ($event) {
                              if ("button" in $event && $event.button !== 1)
                                return null
                              return _vm.middleClick(document)
                            },
                            dblclick: function ($event) {
                              return _vm.dobleClick(document)
                            },
                            contextmenu: function ($event) {
                              $event.preventDefault()
                              return _vm.openContextMenuDocument(
                                document,
                                indexDocument,
                                $event
                              )
                            },
                            dragstart: function ($event) {
                              return _vm.dragFileStart($event, document)
                            },
                            dragend: function ($event) {
                              return _vm.dragFileEnd($event)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "row-file-name" }, [
                            _c("i", {
                              staticClass: "fa-fw fa-lg",
                              class: _vm.getIconFile(
                                document.tipo_documento_id
                              ),
                            }),
                            _vm._v(
                              "  " +
                                _vm._s(document.nombre) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "row-file-date is-size-7 is-hidden-mobile",
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm._f("moment")(
                                      new Date(document.created_at),
                                      "DD/MM/YYYY"
                                    )
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "row-file-size is-size-7 is-hidden-mobile",
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.readableSizeFile(document.peso)) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "infinite-loading",
                      {
                        attrs: { identifier: _vm.identifierLoaderDocuments },
                        on: { infinite: _vm.infiniteHandlerDocuments },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "py-5 is-size-7 is-mono",
                            attrs: { slot: "no-more" },
                            slot: "no-more",
                          },
                          [_vm._v("~ Fin del listado ~")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "py-5 is-size-7 is-mono",
                            attrs: { slot: "no-results" },
                            slot: "no-results",
                          },
                          [_vm._v("~ Fin del listado ~")]
                        ),
                      ]
                    ),
                  ],
                  2
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.showSidebar
            ? _c("sidebar", {
                attrs: { file: _vm.selectedSidebarDocument },
                on: {
                  "update:file": function ($event) {
                    _vm.selectedSidebarDocument = $event
                  },
                  "close-sidebar": _vm.closeSidebar,
                  "folder-permissions": function ($event) {
                    return _vm.$emit("folder-permissions")
                  },
                  "delete-document": () =>
                    _vm.$emit(
                      "delete-document",
                      _vm.selectedFolder === _vm.currentFolder
                    ),
                  "move-document": function ($event) {
                    return _vm.$emit("move-document")
                  },
                  "rename-document": function ($event) {
                    return _vm.$emit("rename-document")
                  },
                  "preview-document": function ($event) {
                    return _vm.$emit("preview-document")
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedDocumentsIndex.length > 1
            ? _c("multiple-sidebar", {
                on: {
                  "move-multiple-documents": function ($event) {
                    return _vm.$emit("move-multiple-documents")
                  },
                  "delete-multiple-documents": function ($event) {
                    return _vm.$emit("delete-multiple-documents")
                  },
                  "unselect-documents": _vm.unselectDocuments,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("context-menu", {
        ref: "menu",
        attrs: { selectedDocuments: _vm.selectedDocuments },
        on: {
          "update:selectedDocuments": function ($event) {
            _vm.selectedDocuments = $event
          },
          "update:selected-documents": function ($event) {
            _vm.selectedDocuments = $event
          },
          "move-multiple-documents": function ($event) {
            return _vm.$emit("move-multiple-documents")
          },
          "rename-document": function ($event) {
            return _vm.$emit("rename-document")
          },
          "folder-permissions": function ($event) {
            return _vm.$emit("folder-permissions")
          },
          "delete-document": () =>
            _vm.$emit(
              "delete-document",
              _vm.selectedFolder === _vm.currentFolder
            ),
          "delete-multiple-documents": function ($event) {
            return _vm.$emit("delete-multiple-documents")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "has-text-centered" }, [
      _c("p", { staticClass: "has-text-white pt-5 pb-2" }, [
        _c("i", {
          staticClass: "fas fa-file-upload fa-2x animated pulse infinite",
        }),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "has-text-white is-size-7" }, [
        _vm._v("Suelte aquí los archivos para subirlos a la carpeta"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row-file-size is-hidden-mobile" }, [
      _c("b", [_vm._v("Peso")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }